(function() {
  'use strict';

  var announcement = document.querySelector('[data-announcement]');
  var announcementClose = document.querySelector('[data-announcement-close]');

  if (announcementClose && announcement) {
    announcementClose.addEventListener('click', function() {
      announcement.classList.add('is-hidden');
      sessionStorage.setItem('cuento-announcement-closed', 'true');
    });

    if (sessionStorage.getItem('cuento-announcement-closed') === 'true') {
      announcement.classList.add('is-hidden');
    }
  }

  var headerMain = document.querySelector('.cuento-header__main');

  if (headerMain) {
    var observer = new IntersectionObserver(
      function(entries) {
        headerMain.classList.toggle('has-scrolled', !entries[0].isIntersecting);
      },
      { threshold: 1, rootMargin: '-1px 0px 0px 0px' }
    );

    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    document.body.prepend(sentinel);
    observer.observe(sentinel);
  }

  var drawer = document.querySelector('[data-drawer]');
  var menuOpen = document.querySelector('[data-menu-open]');
  var drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (menuOpen) menuOpen.addEventListener('click', openDrawer);
  drawerCloseButtons.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
